import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getContrasApi,
  saveContraApi,
  deleteContraApi,
  getContraCodeApi,
} from "../../apiservice/accounts";
import { getAccountBySeachApi } from "../../apiservice/setting";

export const fetchContraList = createAsyncThunk(
  "contra/fetchContraList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getContrasApi({ type: "all" });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createOrUpdateContra = createAsyncThunk(
  "contra/createOrUpdateContra",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveContraApi(payload);
      if (res.data?.error) {
        return rejectWithValue(res.data);
      }
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteContra = createAsyncThunk(
  "contra/deleteContra",
  async (contra_id, { rejectWithValue }) => {
    try {
      const res = await deleteContraApi({ contra_id });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchAccountsForContra = createAsyncThunk(
  "contra/fetchAccountsForContra",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        multiType: [
          "cash_in_hand",
          "bank_account",
          // "capital",
          // "fixed_asset",
          // "loan",
        ],
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchContraCode = createAsyncThunk(
  "contra/fetchContraCode",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getContraCodeApi();
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
